/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import type Category from 'linced-admin/models/goals/category';
import type Subject from 'linced-admin/models/goals/subject';
import type Set from 'linced-admin/models/milestones/set';
import type Page from 'linced-admin/models/posts/page';

// Proto: milestones.LevelTemplate.
export default class Level extends Model {
  declare [Type]: 'milestones/level';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare briefLabel: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @belongsTo('goals/subject', { async: true, inverse: null })
  declare goalSubjectTemplateId: AsyncBelongsTo<Subject>;

  @alias('goalSubjectTemplateId')
  declare goalSubjectTemplate: AsyncBelongsTo<Subject>;

  @alias('goalSubjectTemplateId.id')
  declare goal_subject_template_id: string | null | undefined;

  @belongsTo('goals/category', { async: true, inverse: null })
  declare goalCategoryTemplateId: AsyncBelongsTo<Category>;

  @alias('goalCategoryTemplateId')
  declare goalCategoryTemplate: AsyncBelongsTo<Category>;

  @belongsTo('posts/page', { async: true, inverse: null })
  declare pageTemplateId: AsyncBelongsTo<Page>;

  @alias('pageTemplateId')
  declare pageTemplate: AsyncBelongsTo<Page>;

  @belongsTo('milestones/set', { async: true, inverse: 'levels' })
  declare templateSetId: AsyncBelongsTo<Set>;

  @alias('templateSetId')
  declare templateSet: AsyncBelongsTo<Set>;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;
}
